import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { IDetect } from '@stockcare-shared/directives/scanner-detect.directive';
import { Observable, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-basket-search',
  templateUrl: './basket-search.component.html',
  styleUrls: ['./basket-search.component.scss'],
})
export class BasketSearchComponent implements OnInit, OnDestroy {
  @Input() displayedButtonText: string;

  @Input() header: string = '';
  @Input() icon: string = '';
  @Input() showSearch: boolean = true;
  @Input() showCreate: boolean = false;
  @Input() showHistory: boolean = false;
  @Input() autoFocus: boolean;
  @Input() isReadonly: boolean = false;
  @Input() showRefresh: boolean = true;
  @Input() showKeyboard: boolean = false;
  @Input() showClear: boolean = false;
  @Input() disableKeyPress: boolean = true;
  @Input() disableKeyboard: boolean = true;
  @Input() hideHeader: boolean;
  @Input() searchText: string;
  @Input() basketCleared: Observable<void>;
  @Output() scanClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() disableBasketSearch: EventEmitter<any> = new EventEmitter<any>();
  @Output() enableBasketSearch: EventEmitter<any> = new EventEmitter<any>();
  placeholder: string = 'Search basket';
  subscriptions = new Subscription();

  enableCustomKeyboard: boolean = false;

  @Output() basketSearch = new EventEmitter<string>();

  @ViewChild('searchInputBasketField') searchInputBasketField: ElementRef;

  @Input() set setSearchInput(value: string) {
    if (value === undefined) return;

    this.setSearchText(value);
    
    if (this.searchText == '') {
      this.clearSearchInput();
    }
  };

  get getInputMode() {
    if (this.enableCustomKeyboard) {
      return 'none';
    }
    return 'text';
  }
  
  constructor(
    public settingsService: SettingsService,
  ) {
    this.enableCustomKeyboard = this.settingsService.enableCustomKeyboard();
  }

  ngOnInit() {
    this.subscriptions.add(this.basketCleared.subscribe(() => this.clearSearch()));
  }

  setSearchText(value: string) {
    this.searchText = value;
    this.basketSearch.emit(this.searchText);
  }

  inputFocus(focused: boolean) {
    this.disableKeyPress = focused;
  }

  toggleKeyboard() {
    if (this.disableKeyboard) {
      this.disableKeyboard = false;
      this.enableBasketScanning();
      this.placeholder = 'Type here to search basket';
      this.focusSearchInput();
      return;
    }
    this.disableKeyboard = true;
    this.searchText = '';
    this.disableBasketScanning();
    this.placeholder = 'Search basket';
  }

  clearSearchInput() {
    this.placeholder = 'Search basket';
    this.disableKeyPress = true;
    this.disableKeyboard = true;
    this.searchText = '';
    this.disableBasketScanning();
    this.searchInputBasketField.nativeElement.value = '';
  }

  inputSearch() {
    this.basketSearch.emit(this.searchText);
  }

  clearSearch() {
    this.placeholder = 'Search basket';
    this.disableKeyPress = true;
    this.disableKeyboard = true;
    this.searchText = '';
    this.searchInputBasketField.nativeElement.value = '';
  }

  public onDetected(event: IDetect) {
    if (!event.value.toString() || event.value.toString().length === 0) {
      this.placeholder = 'Search basket';
      this.searchText = '';
    }

    this.basketSearch.emit(event.value.toString());
  }

  disableBasketScanning() {
    this.clearSearch();
    this.disableKeyboard = true;
    this.disableBasketSearch.emit();
    this.placeholder = 'Search basket';
  }

  enableBasketScanning() {
    this.enableBasketSearch.emit();
    this.placeholder = 'Scan to search basket';
  }

  private focusSearchInput() {
    setTimeout(() => {
      this.searchInputBasketField.nativeElement.focus();
    }, 0);
  }

  onDelete() {
    if (this.searchText && this.searchText.length > 0) {
      this.searchText = this.searchText.slice(0, -1);
      this.basketSearch.emit(this.searchText);
    } else {
      this.clearSearch();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
